import React, { lazy } from "react";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Login = lazy(() => import("./pages/auth/Login"));
const ForgotPassword = lazy(() => import("./pages/auth/ForgotPassword"));
const WipePin = lazy(() => import("./pages/wipepin/WipePin"));
const BypassSecurity = lazy(
  () => import("./pages/bypass-security/BypassSecurity")
);

export const paths = {
  DASHBOARD: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  WIPE_PIN: "/wipe-pin",
  BYPASS_SECURITY: "/bypass-security",
};

export const routers = [
  {
    path: "/",
    redirect: paths.DASHBOARD,
    component: Dashboard,
    protected: true,
  },
  {
    path: "/login",
    redirect: paths.LOGIN,
    component: Login,
    protected: false,
  },
  {
    path: "/forgot-password",
    redirect: paths.FORGOT_PASSWORD,
    component: ForgotPassword,
    protected: false,
  },
  {
    path: "/wipe-pin",
    redirect: paths.WIPE_PIN,
    component: WipePin,
    protected: true,
  },
  {
    path: "/bypass-security",
    redirect: paths.BYPASS_SECURITY,
    component: BypassSecurity,
    protected: true,
  },
];
